module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_maedori@3x-16b76a6a56fc9ebd4a4c68b1b7c7a2e0.webp";